var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "persistent": true,
      "title": _vm.$t('attachmentRequest.continueDialog.title'),
      "subtitle": _vm.$t('attachmentRequest.continueDialog.subtitle'),
      "isDialogActive": true,
      "leftText": _vm.$t('attachmentRequest.continueDialog.abort'),
      "rightText": _vm.$t('attachmentRequest.continueDialog.continue'),
      "hideClose": true
    },
    on: {
      "leftClick": _vm.abort,
      "rightClick": _vm.next,
      "close": _vm.abort
    },
    scopedSlots: _vm._u([!_vm.isMobile ? {
      key: "left",
      fn: function fn() {
        return [_c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": _vm.restart
          }
        }, [_vm._v(_vm._s(_vm.$t("attachmentRequest.continueDialog.restart")))])];
      },
      proxy: true
    } : null], null, true)
  }, [_vm.isMobile ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.restart
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportInitializeCard.empty.title")) + " ")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }